module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": ("sub-" + _vm.dparent + "-" + _vm.index)
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_c('a', {
    class: {
      'fontInitial': _vm.isStaticMobilePage
    },
    attrs: {
      "data-toggle": "collapse",
      "data-parent": '#' + _vm.dparent,
      "href": ("#" + _vm.dparent + "-" + _vm.index),
      "aria-expanded": _vm.areaExpanded,
      "aria-controls": (_vm.dparent + "-" + _vm.index)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })])]), _vm._v(" "), _c('div', {
    class: {
      'collapse': !_vm.isOpen,
      'collapse show': _vm.isOpen
    },
    attrs: {
      "id": (_vm.dparent + "-" + _vm.index),
      "role": "tabpanel",
      "aria-labelledby": ("sub-" + _vm.dparent + "-" + _vm.index)
    }
  }, [_c('div', {
    staticClass: "card-block op_5"
  }, [_vm._t("default")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29a9b711"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/faqTab.vue
// module id = 1336
// module chunks = 1 13 39 47